import type { MouseEvent } from 'react'

/**
 * Returns true when a click on a "clickable row" should NOT trigger row-level
 * navigation. Used in combination with an inner `<Link>` that handles real
 * navigation semantics (keyboard, screen reader, cmd/middle-click, right-click
 * "open in new tab"). The row-level onClick is a mouse-only convenience —
 * these guards prevent it from breaking expected behavior:
 *
 * - Modifier keys (cmd/ctrl/shift/alt) → user wants a new tab/window; let
 *   the inner Link handle it.
 * - Interactive child (a, button, input, [role="button"]) → the child already
 *   handled the click; avoid double-navigation.
 * - Active text selection → user was selecting text, not navigating.
 */
export function shouldSkipRowNavigation(e: MouseEvent<HTMLElement>): boolean {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return true
  const target = e.target as HTMLElement
  if (target.closest('a, button, input, [role="button"]')) return true
  if (window.getSelection()?.toString()) return true
  return false
}
